import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import { Curso } from '../models/curso.model';

@Injectable({
  providedIn: 'root',
})
export class CursoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all cursos
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: Curso[] }>(
        `${this.path}/getAllCurso`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(
        // debounceTime(500),
        map((response) => response)
      );
  }

  // Get curso by ID
  public show(id: string): Observable<Curso> {
    return this.apiService
      .get<{ data: Curso; retorno: any }>(`${this.path}/getCursoById/${id}`)
      .pipe(map((response) => response.data as Curso));
  }

  // Create new curso
  public store(curso: Curso): Observable<Curso> {
    return this.apiService
      .post<{ object: Curso }>(`${this.path}/AddCurso`, curso)
      .pipe(map((response) => response.object as Curso));
  }

  // Update existing curso
  public update(curso: Curso): Observable<Curso> {
    return this.apiService
      .put<{ object: Curso }>(`${this.path}/UpdateCurso/`, curso)
      .pipe(map((response) => response.object as Curso));
  }

  // Delete existing curso
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteCursoById/${id}`);
  }

  // Toggle curso status
  public toggleStatus(id: string): Observable<any> {
    return this.apiService.patch(`${this.path}/ToogleCursoStatus/${id}`,)
  }
}
